import React from "react";
import logo from "../../images/logo.svg";

const Brand = (props) => {
  return <img src={logo} alt="" className="site-logo" />;
};

export default Brand;
